import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

const shouldForwardProp = prop => {
  return !['active'].includes(String(prop))
}

export const Container = styled(Flex).attrs({
  display: ['none', 'flex', 'flex', 'flex'],
})`
  width: 100%;
  justify-content: center;
  margin-top: 30px;
  height: 10px;
`

export const Bullet = styled(Flex)`
  margin: 0 5px;
  background-color: ${themeGet('colors.calculator.dot')};
  border-radius: 5px;
  height: 10px;
  width: 20px;
  cursor: pointer;
`

export const ActiveBullet = styled(Bullet).withConfig({
  shouldForwardProp,
})`
  width: 40px;
  background-color: ${themeGet('colors.calculator.action')};
`
